import { render, staticRenderFns } from "./region-form.vue?vue&type=template&id=1fd48867&scoped=true&"
import script from "./region-form.vue?vue&type=script&lang=js&"
export * from "./region-form.vue?vue&type=script&lang=js&"
import style0 from "./region-form.vue?vue&type=style&index=0&id=1fd48867&lang=scss&scoped=true&"
import style1 from "./region-form.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./region-form.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./region-form.vue?vue&type=style&index=3&lang=scss&"
import style4 from "./region-form.vue?vue&type=style&index=4&id=1fd48867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd48867",
  null
  
)

export default component.exports
import {QCard,QForm,QInput,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QStepper,QStep,QMenu,QStepperNavigation,QSpinnerIos,QField,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QForm,QInput,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QStepper,QStep,QMenu,QStepperNavigation,QSpinnerIos,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
